module.exports = __webpack_public_path__ + "img/88.67459e28.jpg";